<template>
	<div class="fi-row">
		<it-link :to="'createConfirmReceiving.do?id='+fi.id" class="fi-rowIcon"><sym-icon name="click"></sym-icon></it-link>
		<div class="fi-row-message">
			<span>{{ confirmMessage }}:</span>
			<object-link :src-id="fi.srcId" :src-type="fi.srcType">{{ fi.srcName }}</object-link>
			<it-link v-if="isMe" :to="'createConfirmReceiving.do?id='+fi.id" class="fbutton">{{ env.msg('forceInfo.complete') }}</it-link>
			<fi-date :value="fi.entered"></fi-date>
		</div>
	</div>
</template>

<script setup lang="ts">
import {ref, computed} from "vue";
import type {ForceInfo} from "@t/processes/ForceInfo.ts";
import {injectEnv} from "@fd/Environment.ts";
import ItLink from "@/router/ItLink.vue";
import SymIcon from "@fd/helpers/SymIcon.vue";
import {SrcType} from "@t/meta/SourceType.ts";
import ObjectLink from "@fd/helpers/ObjectLink.vue";
import FiDate from "@/processes/FiDate.vue";

const props = defineProps<{
	fi:ForceInfo
}>();
const env = injectEnv();

const isMe = computed<boolean>(() => {
	return props.fi.responsible === env.user.login;
});
const confirmMessage = computed<string>(() => {
	let msgKey;
	switch (props.fi.srcType) {
		case SrcType.EVENT:
			msgKey = "forceInfo.confirmEvent";
			break;
		case SrcType.CONTACT:
			msgKey = "forceInfo.confirmContact";
			break;
		case SrcType.OPPORTUNITY:
			msgKey = "forceInfo.confirmOpportunity";
			break;
		case SrcType.BUSCASE:
			msgKey = "forceInfo.confirmBusCase";
			break;
		case SrcType.TASK:
		default:
			msgKey = "forceInfo.confirmTask";
			break;
	}
	return env.msg(msgKey);
});

</script>

<style>

</style>